import SyPagination from "./sy-pagination";

export default SyPagination;